import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

// Styled components
const HeroContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  height: '80vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'white',
  textAlign: 'center',
  overflow: 'hidden',
  backgroundColor: '#0a0a0a',
  [theme.breakpoints.down('md')]: {
    height: '60vh',
  },
  [theme.breakpoints.down('sm')]: {
    height: '50vh',
  },
}));

const HeroContent = styled(Box)(({ theme }) => ({
  position: 'relative',
  zIndex: 10,
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const FactoryImageContainer = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  overflow: 'hidden',
}));

const SlideshowImage = styled('img')<{ isActive: boolean }>(({ isActive }) => ({
  width: '100%',
  height: '100%',
  display: 'block',
  objectFit: 'cover',
  position: 'absolute',
  top: 0,
  left: 0,
  opacity: isActive ? 1 : 0,
  transition: 'opacity 1s ease-in-out',
}));


const HeroSection = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  // Factory images for slideshow
  const factoryImages = [
    '/images/shivay/gallery/IMG_4761.JPG',
    '/images/shivay/gallery/IMG_4762.JPG',
    '/images/shivay/gallery/IMG_4763.JPG',
    '/images/shivay/gallery/IMG_4764.JPG',
    '/images/shivay/gallery/IMG_4765.JPG',
    '/images/shivay/gallery/IMG_4766.JPG',
    //'/images/shivay/gallery/IMG_4767.JPG',
    '/images/shivay/gallery/IMG_4768.JPG',
    '/images/shivay/gallery/IMG_4769.JPG',
    '/images/shivay/gallery/IMG_4770.JPG',
    '/images/shivay/gallery/IMG_4771.JPG',
    '/images/shivay/gallery/IMG_4775.JPG',
    '/images/shivay/gallery/IMG_4776.JPG',
  ];

  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Auto-advance slideshow
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % factoryImages.length);
    }, 3000); // Change image every 3 seconds

    return () => clearInterval(interval);
  }, [factoryImages.length]);

  return (
    <HeroContainer>
      {/* Factory Image Slideshow - Full Cover */}
      <FactoryImageContainer>
        {factoryImages.map((image, index) => (
          <SlideshowImage
            key={index}
            src={image}
            alt={`Shivay Stonex Factory ${index + 1}`}
            isActive={index === currentImageIndex}
            onError={(e: any) => {
              console.error('Factory image failed to load:', image);
              e.target.style.display = 'none';
            }}
          />
        ))}
      </FactoryImageContainer>
      
      {/* Content overlay */}
      <HeroContent>
        {/* Add any content here if needed */}
      </HeroContent>
    </HeroContainer>
  );
};

export default HeroSection; 